import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { IngestProvider } from "datasets/pages/tables/contexts/ingest";
import { TableAccessLevel } from "datasets/types/enums/access-level";
import { ArrowLeft } from "lucide-react";
import { Label } from "~/components/ui/label";
import { RadioGroup, RadioGroupItem } from "~/components/ui/radio-group";
import { NEXTGEN_MAX_CONTENT_WIDTH } from "~/lib/layout";
import { IngestForm } from "./IngestForm";
import { SnowflakeForm } from "./SnowflakeForm";

type DataLocation = "cloud" | "database";

export const AddTable = () => {
  const { datasetId } = useParams<{ datasetId: string }>();
  const [dataLocation, setDataLocation] = useState<DataLocation>("cloud");

  return (
    <div
      className="flex flex-col gap-5"
      style={{ maxWidth: NEXTGEN_MAX_CONTENT_WIDTH, margin: "0 auto", width: "100%" }}
    >
      <div className="flex flex-col gap-1">
        <Link
          to={`/nova/datasets/${datasetId}/tables`}
          className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="size-3" />
          All Tables
        </Link>
        <h1 className="text-xl font-semibold">Add Table</h1>
      </div>

      <div className="flex flex-col gap-2">
        <p className="text-sm font-medium">Where is your data located?</p>
        <RadioGroup
          value={dataLocation}
          onValueChange={(v) => setDataLocation(v as DataLocation)}
          className="flex gap-4"
        >
          <RadioGroupItem value="cloud" id="loc-cloud" label="From File" />
          <RadioGroupItem value="database" id="loc-database" label="Database" />
        </RadioGroup>
      </div>

      {dataLocation === "cloud" && (
        <IngestProvider>
          <IngestForm />
        </IngestProvider>
      )}
      {dataLocation === "database" && <SnowflakeForm accessLevel={TableAccessLevel.READ} />}
    </div>
  );
};
